<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();

const headingBlockData = {
  heading: 'BRUIN Support Articles',
  colorScheme: ['purple-background'],
};

const handleSearch = async (searchQuery: string) => {
  await router.push({ path: '/student-experience/academic-services/bruin-support/bruin-support-articles/results', query: { q: searchQuery } });
};
useHead({
  title: 'BRUIN Support Articles',
  meta: [
    {
      name: 'description',
      content: 'Search BRUIN Support Articles.',
    },
  ],
});

useSeoMeta({
  ogTitle: 'BRUIN Support Articles',
  ogDescription: 'Search BRUIN Support Articles.',
});
</script>

<template>
  <div>
    <FlexibleHeading :block-data="headingBlockData" />

    <section class="bg-accent-25">
      <LayoutsContainer>
        <BruinSearchForm @search="handleSearch" />
      </LayoutsContainer>
    </section>
  </div>
</template>
